import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const data: any = localStorage.getItem("data")
    ? JSON.parse(localStorage.getItem("data") as any)
    : null;
  const roleData = data;
  return data?.token ? (
    (roleData?.role?.role_code == "SCHOOL_USER") ? (
      <Outlet />
    ) : (
      <Navigate to="/" />
    )
  ) : (
    <Navigate to="/account/login" />
  );
};

export default ProtectedRoute;
